<div class="m-grid m-grid--hor m-grid--root m-page" data-gramm="false" data-gramm_editor="false" data-enable-grammarly="false"
    [ngClass]="{'subscription-bar-visible': subscriptionStatusBarVisible()}" [class.cp-embed]="embedMode">
    <!-- BEGIN: Header -->
    <header-bar *ngIf="!installationMode && !embedMode"></header-bar>
    <!-- END: Header -->
    <!-- begin::Body -->

    <!-- <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body bodyclass" [ngClass]="{'admincls': isAdminUser, 'nonadmincls': !isAdminUser}"> -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body bodyclass"
        id="DivAdmin">
        <!-- BEGIN: Left Aside -->
        <button *ngIf="ui.leftMenuUsed() && !embedMode"
            class="m-aside-left-close m-aside-left-close--skin-{{s('App.UiManagement.Left.AsideSkin')}}"
            id="m_aside_left_close_btn">
            <i class="la la-close" [attr.aria-label]="l('Close')"></i>
        </button>

        <!-- <ng-container *ngIf="isAdminUser"> -->
        <!-- <div *ngIf="ui.leftMenuUsed() && isAdminUser" id="m_aside_left" class="m-grid__item	m-aside-left m-aside-left--skin-{{s('App.UiManagement.Left.AsideSkin')}}"> -->
        <div *ngIf="ui.leftMenuUsed() && !embedMode" id="m_aside_left"
            class="m-grid__item	m-aside-left m-aside-left--skin-{{s('App.UiManagement.Left.AsideSkin')}}">
            <!-- BEGIN: Aside Menu -->

            <!-- {{isAdminUser}} -->
            <side-bar-menu></side-bar-menu>
        </div>
        <!-- END: Aside Menu -->
        <!-- </ng-container> -->
        <!-- END: Left Aside -->
        <div class="m-grid__item m-grid__item--fluid m-wrapper">
            <!-- dashboard.component.html -->
            <app-trial-banner *ngIf="!embedMode"></app-trial-banner>

            <router-outlet></router-outlet>
        </div>
    </div>
    <!-- <div *ngIf="!isAdminUser" class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body" style="background-color: #f1f4f5 !important;padding-left: 0px !important;">
        <button *ngIf="ui.leftMenuUsed()" class="m-aside-left-close m-aside-left-close--skin-{{s('App.UiManagement.Left.AsideSkin')}}" id="m_aside_left_close_btn">
            <i class="la la-close" [attr.aria-label]="l('Close')"></i>
        </button>
        <div *ngIf="ui.leftMenuUsed()" id="m_aside_left" class="m-grid__item	m-aside-left m-aside-left--skin-{{s('App.UiManagement.Left.AsideSkin')}}">
            <side-bar-menu></side-bar-menu>
        </div>
        <div class="m-grid__item m-grid__item--fluid m-wrapper">
            <router-outlet></router-outlet>
        </div>
    </div> -->
    <!-- end:: Body -->
    <!-- begin::Footer -->
    <footer-bar *ngIf="!embedMode"></footer-bar>
    <!-- end::Footer -->
</div>
<!-- <chat-bar *ngIf="!installationMode"></chat-bar> -->

<div id="apiErrorModal" class="modal fade" tabindex="-1" role="dialog" style="display:none">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 id="modalTitle">Network Unreachable</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="popup-body-font">
                    <i class="fa fa-warning text-danger" aria-hidden="true"
                        style="font-size:x-large;padding-right:5px;"></i>
                    <span id="modalBodyText">Unable to connect to the server. Please check your network
                        connection.</span>
                </p>
            </div>
            <div class="modal-footer">
                <button type="button" (click)="reloadBtn()" class="btn btn-danger" data-dismiss="modal">Reload</button>
                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>
<app-install-popup [(visible)]="showPopup"></app-install-popup>